import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { SectionCard } from "../styles/StyledComponents";

function HeroSection() {
  return (
    <SectionCard sx={{ mb: 4 }}>
      <Box
        sx={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
          p: 4,
          borderRadius: "16px 16px 0 0",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: -50,
            right: -50,
            width: 200,
            height: 200,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.1)",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: -30,
            left: -30,
            width: 150,
            height: 150,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.1)",
          }}
        />
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <Chip
            label="Risparmia fino a 300€/anno"
            size="small"
            sx={{
              bgcolor: "rgba(255,255,255,0.2)",
              color: "white",
              fontWeight: 600,
              mb: 2,
            }}
          />
          <Typography variant="h3" sx={{ fontWeight: 700, mb: 2 }}>
            Tariffe Energia e Gas.
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
            Risparmia sulle Bollette!
          </Typography>
          <Typography variant="h6" sx={{ opacity: 0.95, mb: 3 }}>
            Confronta le migliori offerte luce e gas del mercato italiano.
          </Typography>
          <Typography variant="body1" sx={{ opacity: 0.9 }}>
            <strong>Gratuito, imparziale e in pochi minuti.</strong>
          </Typography>
        </Box>
      </Box>
    </SectionCard>
  );
}

export default HeroSection;
